import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { FontEmphasis } from '@prisjakt/ui/text';
import { IconDelivery } from '@prisjakt/ui/icon';
import { ShippingCollection, StockStatus } from 'src/types';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import {
  ShippingType,
  getDeliveryDaysText,
  getStandardizedDeliveryText,
} from './utils';
import { Wrapper, IconWrapper, CaptionText } from './styles';
import { MediumUp, MobileOnly } from 'src/ui/block';

interface IDeliveryTimeProps {
  shipping?: ShippingCollection | null;
  stockStatus?: StockStatus | null;
}

export const DeliveryTime: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IDeliveryTimeProps>
>> = props => {
  const { shipping, stockStatus } = props;
  const { t } = useContext(AppContext);
  const deliveryDaysText = getDeliveryDaysText(
    t,
    ShippingType.CHEAPEST,
    shipping
  );
  const standardizedDeliveryText = getStandardizedDeliveryText(t, stockStatus);
  const tooltipLabel = t('product', 'delivery-time.label');
  const deliveryTimeText = deliveryDaysText ?? standardizedDeliveryText;

  if (!deliveryDaysText && !standardizedDeliveryText) {
    return null;
  }

  return (
    <Wrapper>
      <MediumUp>
        <MediumUp>
          <Tooltip
            placement={TooltipPlacement.TOP}
            title={`${tooltipLabel}: ${deliveryTimeText}`}
            renderOnMouseOver
          >
            <IconWrapper>
              <IconDelivery color="base400" size={20} />
            </IconWrapper>
          </Tooltip>
        </MediumUp>
      </MediumUp>

      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        <MobileOnly>{deliveryDaysText}</MobileOnly>
        <MediumUp>{deliveryTimeText}</MediumUp>
      </CaptionText>
    </Wrapper>
  );
};
